import { useMemo } from 'react'
import type { HierarchyLevel } from '@/api/productHierarchy'
import { useHierarchyLevel } from '@/hooks/useHierarchy'
import { Combobox } from '@/components/ui/combobox'
import { MultiSelect } from '@/components/ui/multi-select'

interface HierarchyValueSelectProps {
  level: HierarchyLevel
  value: string | string[]
  onChange: (value: string | string[]) => void
  multiple: boolean
  parentId?: string | null
}

export function HierarchyValueSelect({
  level,
  value,
  onChange,
  multiple,
  parentId,
}: HierarchyValueSelectProps) {
  const { data: nodes, isLoading } = useHierarchyLevel(level, parentId)

  const options = useMemo(
    () =>
      (nodes ?? []).map(n => ({
        value: n.id,
        label: `${n.code} - ${n.name}`,
      })),
    [nodes]
  )

  if (multiple) {
    const arrValue = Array.isArray(value) ? value : value ? [value] : []
    return (
      <MultiSelect
        options={options}
        value={arrValue}
        onValueChange={onChange}
        placeholder="Select values..."
        isLoading={isLoading}
        className="flex-1"
      />
    )
  }

  const strValue = Array.isArray(value) ? (value[0] ?? '') : (value ?? '')

  return (
    <Combobox
      options={options}
      value={strValue || null}
      onValueChange={v => onChange(v ?? '')}
      placeholder={isLoading ? 'Loading...' : 'Select value...'}
      isLoading={isLoading}
      className="flex-1"
    />
  )
}
